<div>
    <div class="header-card" [ngStyle]="objColor">
        <div class="text-header">
            <div></div><span aria-live="assertive"><span>Obrigado por responder.</span></span>
        </div>
    </div>
    <div class="thanks-card">
        <div class="photo-div" style="width: 100% ;position: absolute; margin-top: 50px;">
            <img style="height: 80px" class="m-b-10" [src]="
                    survey.url_photo != null && survey.url_photo != ''
                      ? survey.url_photo
                      : survey.companies.url_logo
                  " />
        </div>
        <div class="text-div">
            <div class="text-center">
                <div [innerHTML]="tagsReplace(survey.thankyou_message)">
                </div>
            </div>
        </div>
    </div>
</div>